import React from 'react';
import { StyleSheet, Text, View } from 'react-native';
import { QuaternaryActionButtonProps, ACTION_BUTTON_MODE } from './QuaternaryActionButton.types';
import { QuaternaryOnDarkButton } from '../quaternary-on-dark-button/QuaternaryOnDarkButton';
import { IconQuaternaryOnDarkButton } from '../../icon-buttons/icon-quaternary-on-dark-button/IconQuaternaryOnDarkButton';
import { BaseHoverTooltip } from '../../../../components/tooltips/base-hover-tooltip/BaseHoverTooltip';
import { BUTTON_TYPES, BUTTON_SIZES, BUTTON_LAYOUTS } from '../button/Button.constants';
import { TooltipPosition } from '../../../../components/tooltips/Tooltip.types';
import { neutrals } from 'src/theme/colors';

export const QuaternaryActionButton: React.FC<QuaternaryActionButtonProps> = ({
  text,
  iconName,
  mode,
  onPress,
  size = BUTTON_SIZES.REGULAR,
  type = BUTTON_TYPES.ICON_LEFT,
  disabled,
  testID,
  textNumberOfLines = 1,
  layout = BUTTON_LAYOUTS.HUG,
  ...buttonProps
}) => {
  if (mode === ACTION_BUTTON_MODE.LABEL) {
    return (
      <QuaternaryOnDarkButton
        text={text}
        iconName={iconName}
        type={type}
        size={size}
        onPress={onPress}
        disabled={disabled}
        testID={testID}
        textNumberOfLines={textNumberOfLines}
        layout={layout}
        {...buttonProps}
      />
    );
  }

  return (
    <View style={styles.iconOnlyWrapper}>
      <BaseHoverTooltip
        TooltipContent={() => (
          <View style={styles.tooltipContainer}>
            <Text style={styles.tooltipText}>{text}</Text>
          </View>
        )}
        position={TooltipPosition.TOP}
      >
        <IconQuaternaryOnDarkButton
          iconName={iconName}
          size={size}
          onPress={onPress}
          disabled={disabled}
          testID={testID}
          accessibilityLabel={text}
          {...buttonProps}
        />
      </BaseHoverTooltip>
    </View>
  );
};

const styles = StyleSheet.create({
  iconOnlyWrapper: {
    alignSelf: 'flex-start',
  },
  tooltipContainer: {
    paddingHorizontal: 12,
    paddingVertical: 6,
    alignItems: 'center',
  },
  tooltipText: {
    color: neutrals.neutralGrays.coal,
    fontSize: 12,
    lineHeight: 15.6,
    fontWeight: '700',
    whiteSpace: 'nowrap',
  },
});
